import { useLang } from "@/i18n/LanguageContext";

export function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-[#F3EFE6] border-y border-[#4A5D3E]/10 py-5 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {items.map((phrase, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif-display text-xl sm:text-2xl italic text-[#4A5D3E]/80">
              {phrase}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#D8CFBC]" />
          </span>
        ))}
      </div>
    </div>
  );
}
